export function InfoRow({ label, value, caption }) {
  if (value === null || value === undefined || value === "") {
    return (
      <div className="text-xs text-gray-500 space-y-1">
        <div className="uppercase tracking-wide text-[10px]">{label}</div>
        <div className="text-sm text-gray-400 font-semibold">—</div>
        {caption && <div className="text-[10px] text-gray-400">{caption}</div>}
      </div>
    );
  }

  return (
    <div className="text-xs text-gray-500 space-y-1">
      <div className="uppercase tracking-wide text-[10px]">{label}</div>
      <div className="text-sm font-semibold text-gray-900">{value}</div>
      {caption && <div className="text-[10px] text-gray-400">{caption}</div>}
    </div>
  );
}

export function SectionTitle({ title }) {
  return (
    <div className="flex items-center justify-between mb-2">
      <div className="text-[10px] uppercase tracking-wider text-gray-500">
        {title}
      </div>
    </div>
  );
}
